<template>
	<EMCoreTemplate category="Core" identity="address" entity="crm_address"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		name: 'Address',
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementCore/containers/Address.vue